import { Component, OnInit, Inject } from "@angular/core";
import { HttpService } from "src/providers/http.service";
import { AuthService } from "src/providers/auth.service";
import { Router } from "@angular/router";
import { ENV } from "../environments/environment-variables.token";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
	constructor(
		public http: HttpService,
		public router: Router,
		public auth: AuthService,
		@Inject(ENV) public ENV: any,
	) { }

	ngOnInit() {
		// title = 'yd-check-in';
		this.http.getToken().then(token => {
			if (token) {
				// this.auth.me();
			}
		});
	}
}
